import { useMutation } from '@tanstack/react-query';
import { updateGoalOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';
import { GoalRoadmapSortingOptions } from 'shared/types/user-settings';

export const useUpdateGoalOrderMutation = () =>
  useMutation({
    mutationFn: async ({
      newOrder,
      option,
    }: {
      newOrder: ID[];
      option: GoalRoadmapSortingOptions;
    }) => updateGoalOrder(newOrder, option),
  });
